import { c as _c } from "react/compiler-runtime";
import styles from "./Inngress.module.scss";
import { NavLink } from "../../../shared/components/Navbar/Navbar";
import { LinkType, Links } from "../Links/Links";
import { PortableText } from "@portabletext/react";
export const Inngress: React.FC<{
  header: string;
  content: any[];
  links: (LinkType | NavLink)[];
}> = t0 => {
  const $ = _c(12);
  const {
    header,
    content,
    links
  } = t0;
  let t1;
  if ($[0] !== links) {
    t1 = <div className={styles.links}><Links links={links} /></div>;
    $[0] = links;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== header) {
    t2 = <p className="inngress">{header}</p>;
    $[2] = header;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== content) {
    t3 = <div className={styles.maincontent}><PortableText value={content} /></div>;
    $[4] = content;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className={styles.intro}>{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <div className={styles.ingress__container}>{t1}{t4}</div>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};